/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 11:11:55
 * @Description: file content
 */
import React, { Component } from 'react';
import { createPageIcon, getSysFieldid, getGlobalStorage, getTopWindow, ajax, pageTo, microAppUtil, getMultiLang } from '@platform/api';
import { BackBtn, Hexagon } from '@platform/base';
import { Metainfo } from '../MetaInfoBox';
require('./index.less');

export default class BillInfo extends Component {
    constructor(props) {
        super(props);
        this.props.getThis(this);
        this.state = {
            showBackBtn: true,
            showBillCode: typeof this.props.events.showBillCode !== "undefined" ? this.props.showBillCode : true,
            billCode: this.props.events.billCode,
            title: this.props.events.title,
            tagVisibility: {},
            showMetaInfo: false,
            tagsInfo: [], //存储要渲染的标签文案和标签样式
            pageIconName: '',
            langJson: {},
        };
        this.formItemIsListener = false; //判断是否监听过
        this.currentPageAppCode = pageTo && pageTo.getAppCode ? pageTo.getAppCode() : '';
    }

    // UNSAFE_componentWillMount() {
    //     let callback = (json, bool) => {
    //         if (bool) {
    //             this.setState({ langJson: json });
    //         }
    //     };
    //     getMultiLang({ moduleId: 'container_billInfo', callback });
    // }
    componentWillReceiveProps(nextProps) {
        if (nextProps.events.title !== this.props.events.title) {
            this.setState({ title: nextProps.events.title });
        }
        if (nextProps.pageScope.formDataSource) {
            this.getTagsInfo(); // 有时领域不会给标签字段设置值，先初始化一遍
            this.ListenFormItem(); //正常节点生成的页面 
        }
    }
    componentDidMount() {
        this.getTagsInfo(); // 有时领域不会给标签字段设置值，先初始化一遍
        this.ListenFormItem(); //监听低代码生成的页面期间规则-组织
        //根据参数appCode查询应用图标名称
        this.requestIconName();
    }

    ListenFormItem = () => {
        let { pageScope } = this.props,
            { headcode, pageTitles = [] } = pageScope.state.meta || {},
            fieldKeys = [];
        //需要监听的form字段
        pageTitles.forEach(titleTag => {
            fieldKeys.push(titleTag.statuslabel);
        });
        if (fieldKeys.length && !this.formItemIsListener) {
            pageScope.form.addFormItemListener(headcode, fieldKeys, this.getTagsInfo);
            this.formItemIsListener = true;
        }
    }

    showTemplateInfo = () => {
        let { pageScope } = this.props;
        let { pageid } = pageScope.state.meta || {};
        pageid && pageScope.modal.show('metaInfo');
    }

    //获取标题标签样式 
    getTagsInfo = () => {
        const { pageScope } = this.props;
        let { tagVisibility } = this.state,
            { getFormItemsValue, getFormItem } = pageScope.form,
            { headcode: formId, pageTitles = [] } = pageScope.state.meta || {},
            tagsInfo = [];
        //检查标签信息中是否存在此标签
        let styleInTagsInfo = (tagsInfo, newFieldKey) => {
            let result = false;
            tagsInfo.forEach(tagInfo => {
                if (tagInfo.fieldKey == newFieldKey) {
                    result = true;
                }
            });
            return result;
        };
        pageTitles.forEach(titleTag => {
            let { statuslabel: fieldKey, designlabelcontent } = titleTag;
            if (pageScope.formDataSource[formId] && typeof designlabelcontent === "string") {
                let value = getFormItemsValue(formId, fieldKey) || {};
                let label = getFormItem(formId, fieldKey)?.label;
                let style = JSON.parse(designlabelcontent).find(tagStyle => tagStyle.key === value.value); //获取对应渲染样式
                if (tagVisibility[fieldKey] === false || !style || !value.display) {
                    return;
                } else {
                    style.fieldKey = fieldKey;
                    style.value = value.display;//用表单上的值
                    style.label = label;
                    if (!styleInTagsInfo(tagsInfo, fieldKey)) {
                        tagsInfo.push(style);
                    }
                }
            }
        });
        this.setState({ tagsInfo });
    }

    requestIconName = () => {
        const { events } = this.props;
        const { appCode } = events;
        if (appCode && appCode != this.currentPageAppCode) {
            ajax({
                url: '/nccloud/platform/appregister/queryappimage.do',
                data: { appcode: appCode },
                success: res => {
                    let pageIconName = res.data || 'default';
                    let nccIcon = getGlobalStorage('localStorage', 'nccIcon') || '';
                    if (pageIconName == 'default') {
                        if (nccIcon) {
                            pageIconName = nccIcon + '_';
                        }
                    } else {
                        let fileName = pageIconName.slice(0, pageIconName.length - 1);
                        pageIconName = fileName + '/' + (nccIcon ? nccIcon + '_' : '') + pageIconName;
                    }
                    this.setState({ pageIconName });
                },
            });
        }

    }

    render() {
        const { events, pageScope } = this.props;
        let { showBackBtn, showBillCode, billCode, title = '', tagsInfo, pageIconName } = this.state;
        let { initShowBackBtn = true, backBtnClick, titleClick, showPageIcon = true, billCodeFromEvent = false, appCode } = events;
        //billcode 和 showBillCode 也可以从props中传递过来
        showBillCode = showBillCode || events.showBillCode;
        billCode = billCodeFromEvent ? (events.billCode || billCode) : (billCode || events.billCode);
        //let pageIcon = typeof createPageIcon === 'function' ? createPageIcon() : null;
        let fontClass = (window.nccFontSize) || (getTopWindow().nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';

        let titleFontSize = '';
        if (fontClass) {
            switch (fontClass) {
                case 'large':
                    titleFontSize = 'title-font-size-large';
                    break;
                case 'medium':
                    titleFontSize = 'title-font-size-medium';
                    break;
                default:
                    break;
            }
        }
        return (<div className={`BillHeadInfoWrap ${showBackBtn && initShowBackBtn ? 'BillHeadInfoWrap-showBackBtn' : ''}`}>
            {
                showBackBtn && initShowBackBtn &&
                <BackBtn
                    onClick={backBtnClick && backBtnClick}
                    pageScope={pageScope}
                />
            }
            {showPageIcon && (
                (appCode && appCode != this.currentPageAppCode) ?
                    pageIconName && <img
                        src={require(`../../static/images/pageMainIcon/${pageIconName}.svg`)}
                        className='page-title-Icon'
                        onDoubleClick={this.showTemplateInfo}
                    /> :
                    typeof createPageIcon === 'function' && createPageIcon(this.showTemplateInfo)
            )}
            <span
                className={`bill-info-title ${titleFontSize}`}
                fieldid={getSysFieldid(`${title}_title`)}
                onClick={() => {
                    if (typeof titleClick === "function") {
                        titleClick();
                    }
                }}
            >
                {title && title}
            </span>
            {
                showBillCode &&
                <span className="bill-info-code">{billCode && `：${billCode}`}</span>
            }
            <div className="bill-info-tag">
                {tagsInfo.map(tag => {
                    let { fieldKey, key, borderRadius, color, value, icon, label } = tag;
                    return <Hexagon key={fieldKey + key} iconForTitle={true} text={value} backgroundColor={color} borderRadius={borderRadius} icon={icon} tipInfo={{ overlay: `${label}:${value}` }} />;
                })}
            </div>
        </div>
        );

    }
}
